// extracted by mini-css-extract-plugin
export default {"infoMsg":"infoMsg---dloTZ","card_class":"card_class---QeEn2"};